<app-loading [isLoading]="loading"></app-loading>
<app-notices class="notices"></app-notices>
<router-outlet>
  <app-spinner></app-spinner>
</router-outlet>

<ng-container *ngIf="whatsappBubble$ | async as wa">
  <app-whatsapp-bubble
    *ngIf="wa.show"
    [e164Number]="wa.e164Number"
    [buildingName]="wa.buildingName"
  ></app-whatsapp-bubble>
</ng-container>
